import { useResourceDrawerIfAvailable } from '@ctw/shared/context/resource-drawer-context';
import { useResourceModalIfAvailable } from '@ctw/shared/context/resource-modal-context';

export interface OpenDrawerResource {
  resourceType: string;
  id: string;
}

/**
 * Identifies the resource currently displayed in a `ResourceDrawer` or `ResourceModal`, if either
 * is open. Tolerates the absence of either provider. Prefers the drawer when both are open.
 */
export const useOpenDrawerResource = (): OpenDrawerResource | undefined => {
  const drawerState = useResourceDrawerIfAvailable();
  const modalState = useResourceModalIfAvailable();

  if (drawerState?.isDrawerOpen && drawerState.fetchedDeepLinkResource) {
    return {
      resourceType: drawerState.fetchedDeepLinkResource.resourceType,
      id: drawerState.fetchedDeepLinkResource.id,
    };
  }

  if (modalState?.isModalOpen && modalState.fetchedDeepLinkResource) {
    return {
      resourceType: modalState.fetchedDeepLinkResource.resourceType,
      id: modalState.fetchedDeepLinkResource.id,
    };
  }

  return undefined;
};
